import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

/**
 * Get the company ID for the currently logged-in user
 * @returns {Promise<string|null>} The company ID or null if not found
 */
export async function getCurrentUserCompanyId() {
  const user = auth.currentUser;
  if (!user) {
    console.warn('No authenticated user found');
    return null;
  }

  try {
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (userDoc.exists()) {
      const companyId = userDoc.data()?.companyId;
      if (!companyId) {
        console.warn('User has no company ID assigned');
        return null;
      }
      return companyId;
    } else {
      console.warn('User profile document not found');
      return null;
    }
  } catch (error) {
    console.error('Error fetching user company ID:', error);
    return null;
  }
}

/**
 * Get user profile including company and role
 * @returns {Promise<object|null>} User profile data or null
 */
export async function getCurrentUserProfile() {
  const user = auth.currentUser;
  if (!user) return null;

  try {
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (userDoc.exists()) {
      return { uid: user.uid, ...userDoc.data() };
    }
    return null;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
}

/**
 * Get the current authenticated user's data (alias for getCurrentUserProfile)
 * @returns {Promise<object|null>} User data with groups, roles, companyId, etc.
 */
export async function getCurrentUserData() {
  return getCurrentUserProfile();
}
